import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

interface Props {
  fileName: string;
  title?: string;
}
export const OptimizedImage: React.FC<Props> = props => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { regex: "/(jpg)|(png)|(jpeg)/" } }) {
        edges {
          node {
            base
            childImageSharp {
              fluid(quality: 100) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `);

  const image = data.allFile.edges.find(n =>
    n.node.base === props.fileName ? props.fileName : null,
  );

  if (image) {
    return (
      <Img
        title={props.title ? props.title : props.fileName}
        alt={props.fileName}
        fluid={image.node.childImageSharp.fluid}
      />
    );
  } else {
    return null;
  }
};
